module.exports = "<div class=\"warn-last-day\" ng-show=\"!$ctrl.hideWarningCard\">\n  <span class=\"icon icon-warning\"></span>\n  <p class=\"warn-last-day-message\">\n    {{'VACATIONS_ABSENCES.WARNING_REQUEST_VACATION.HOME_MESSAGE' | translate}} {{$ctrl.date}}\n  </p>\n  <span class=\"icon-cross-blue\"\n        ng-if=\"$ctrl.isMobileApp\"\n        ng-click=\"$ctrl.hideWarningVacation()\">\n  </span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/vacations-absences.module/components/warnLastDay/warnLastDay.html
// module id = 1504
// module chunks = 0